/**
 * Created by Gustavo on 16/08/2016.
 */

import { NgModule, ModuleWithProviders } from "@angular/core";

//UTILS PROVIDERS
import {
    AuthSas,
    AuthHttpSas,
    ErrorHandlerSas,
    AuthHttpWrapperSas,
    XhrSas,
    AuthXhrSas,
    AuthXhrWrapperSas,
    ErrorHandlerBuilderSas,
    ConfigSas
} from './index';

//SAS PROVIDERS

@NgModule({providers : [
  AuthSas,
  AuthHttpSas,
  ErrorHandlerSas,
  AuthHttpWrapperSas,
  XhrSas,
  AuthXhrSas,
  AuthXhrWrapperSas,
  ErrorHandlerBuilderSas,
  ConfigSas
]
})
export class SasModule {
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/sas/sas.module.ts